<script setup>
import { computed } from 'vue'

const props = defineProps({ status: Number })

const title = computed(() => {
  return {
    503: '503: Service Unavailable',
    500: '500: Server Error',
    404: '404: Page Not Found',
    403: '403: Forbidden',
  }[props.status]
})

const description = computed(() => {
  return {
    503: 'Sorry, we are doing some maintenance. Please check back soon.',
    500: 'Whoops, something went wrong on our servers.',
    404: 'Sorry, the page you are looking for could not be found.',
    403: 'Sorry, you are forbidden from accessing this page.',
  }[props.status]
})
</script>

<template>
  <div class="mx-auto flex max-w-xl flex-col items-center py-20 text-center">
    <span class="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-white/[0.05] text-2xl text-nomad-accent ring-1 ring-inset ring-white/10">
      <span class="icon-music"></span>
    </span>
    <h1 class="nl-title text-3xl md:text-4xl">{{ title }}</h1>
    <p class="mt-3 text-lg text-nomad-300">{{ description }}</p>
    <a href="/" class="nl-btn-primary mt-8">Back to Heesify</a>
  </div>
</template>